<template lang='pug'>
  v-card
    v-card-title.dialog-card-title
      p Generar Factura de gastos
      v-icon(color="white" aria-label="Close" @click='cancel') mdi-close
    v-card-text.mt-2
      v-form
        v-container(pa-0='')
          v-layout(wrap='')
            v-flex(xs12='', md12='')
              .pa-1.purchase-form
                v-snackbar(v-model='snackbar',  :color='color',  center top  :timeout="6000")
                  | {{ message }}
                  v-btn(dark='', text='', @click='snackbar = false')
                    | Close
                v-row
                  v-col(cols="12" md="6")
                    v-select.rounded-xl(
                    label='Escoje un destino',
                    elevation=0
                    outlined
                    :items='locations',
                    v-model='model.location_to',
                    item-text='name',
                    return-object, dense='', solo='',
                    clearable='',
                    @click:clear='clearShopSelection')
                      template(slot='selection', slot-scope='data')
                        v-flex(xs2='')
                          v-avatar(size='25px')
                            img( style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                        v-flex.ml-1(style='font-size:10px;')
                          | {{ data.item.name }}
                      template(slot='item', slot-scope='data')
                        v-avatar(size='25px')
                          img(style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                        v-list-tile-content
                          v-list-tile-title(v-html='data.item.name')
                  v-col(cols="12" md="6")
                    v-text-field(v-model='model.title', :counter='30', label='Razón del gasto', required='')
                  v-col(cols="12" md="6").text-center
                    v-flex.xs12.md6.ma-auto(class="inputGroupClass")
                      input.d-none(ref="file" type="file" @change="handleImageUpload" accept="image/*")
                      .font-weight-bold.grey--text(v-if="!imageLoading")
                        | Adjuntar comprobante
                      v-row.justify-center
                        v-progress-circular(v-show='imageLoading' :size='30', :width='3', color='primary', indeterminate='')
                      v-card.pa-1.mx-auto.mt-0.d-inline-flex.v-card--account(v-if="!imageLoading" :class="!!model.pictures? 'success--text' : 'grey--text'" outlined="" height="200" width="200" @click="$refs.file.click()")
                        v-img(contain v-if='model.pictures && model.pictures.imageInput1' :src="model.pictures.imageInput1" height="180" width="100%")
                        v-icon.mx-auto(v-else="" size="96")
                          | mdi-upload
                  v-col(cols="12" md="6")
                      v-text-field(v-model='model.amount' type='number' label='Monto' required='' prefix ='$')
                      v-textarea(v-model='model.description', :counter='300', label='Descripcion del gasto', required='')
                .text-center
                  v-btn(@click='cancel') Cancelar
                  v-btn(color='#008e95', @click='save' :loading="isLoading" :disabled='invalidForm()' )
                    | GUARDAR

</template>
<script>
  import Preview from '../preview/ProductPreview'
  import imageCompression from 'browser-image-compression'
  import * as firebase from 'firebase'
  import loaders from '../../../plugins/mixins/loaders'
  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  })
  export default {
    components: {
      Preview: Preview,

    },
    filters: {
      moneyFormat: function (value) {
        return formatter.format(value)
      },
    },

    mixins: [loaders],
    props: {
      model: Object,
    },

    data () {
      return {
        isLoading: false,
        message: '',
        snackbar: false,
        color: 'success',
        rows: 1,
        valueType: '',
        slider: 10,
        imageRef: '',
        e1: 0,
        show: false,
        isMobile: false,
        imageLoading: false,
        audioLoading: false,
      }
    },

    computed: {
      user () {
        return this.$store.state.users.user
      },
      locations () {
        return this.$store.getters['shops/getItems']
      },
      expensesTypes () {
        return ['Unico', 'Diario', 'Semanal', 'Quincenal', 'Mensual', 'Anual']
      },

    },
    mounted () {
      this.onResize()
    },

    methods: {
      pickFile (ref) {
        this.$refs[ref].click()
        this.imageRef = ref
      },
      uploadToServer (file) {
        const vm = this
        const storageRef = firebase.storage().ref()
        let userId
        if (vm.user.adminUid) {
          userId = vm.user.adminUid
        } else {
          userId = vm.user.uid
        }
        vm.model.id = vm.model.id ? vm.model.id : firebase.database().ref().child(`users/${userId}/transactions/expenses`).push().key
        const metadata = {
          contentType: file.type,
        }
        // Push to child path.
        // [START oncomplete]
        storageRef.child(`users/${userId}/expenses/pictures/${vm.model.id}/imageInput1`).put(file, metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            vm.model.pictures.imageInput1 = url
            vm.imageLoading = false
            setTimeout(vm.isLoading = false, 2000)
          })
        }).catch(function (error) {
          console.error('Upload failed:', error)
          vm.imageLoading = false
          setTimeout(vm.isLoading = false, 2000)
        })
      },
      async handleImageUpload (event) {
        const vm = this
        vm.imageLoading = true
        const imageFile = event.target.files[0]
        // console.log('originalFile instanceof Blob', imageFile instanceof Blob) // true
        // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`)

        const options = {
          maxSizeMB: 0.3,
          maxWidthOrHeight: 800,
          useWebWorker: true,
          maxIteration: 8,
        }
        try {
          const compressedFile = await imageCompression(imageFile, options)
          // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob) // true
          // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`) // smaller than maxSizeMB
          if (imageFile.size > compressedFile.size) {
            // console.log('compressed is smaller')
            await vm.uploadToServer(compressedFile)
          } else {
            // console.log('original is smaller')
            await vm.uploadToServer(imageFile)
          } // if original is smaller
        } catch (error) {
          // console.log(error)
          vm.imageLoading = false
        }
      },
      clearShopSelection () {
        this.model.location_to = null
      },
      reset () {
        this.model = {
          title: '',
          description: '',
          amount: '',
          type: '',
          location_to: null,
          pictures: {
            imageInput1: '',
          },
        }
      },
      cancel () {
        this.reset()
        this.$emit('close')
      },
      save () {
        // console.log(this.model)
        const vm = this
        let valid = true
        vm.model.typeExpense = 'Único'
        if (vm.model.title === '' || vm.model.description === '' || vm.model.typeExpense === '') {
          vm.message = 'Verifica los datos del formulario'
          vm.snackbar = true
          vm.color = 'red'
          // console.log(vm.message)
          valid = false
        }

        if (valid) {
          if (vm.model.reference_number) {
            vm.$store.dispatch('transactions/updateBill', vm.model).then(function () {
              vm.reset()
              vm.message = 'Factura de compra actualizada correctamente'
              vm.snackbar = true
              vm.color = 'green'
              vm.$emit('close')
            })
          } else {
            const transaction = {
              type: 'expenses',
              title: vm.model.title,
              description: vm.model.description,
              amount: vm.model.amount,
              typeExpense: vm.model.typeExpense,
              time: vm.$moment().format(),
              location_to: vm.model.location_to,
              pictures: vm.model.pictures || {
                imageInput1: '',
              },
            }
            // console.log(transaction)
            // // console.log('envio valido' , transaction);
            vm.$store.dispatch('transactions/sendBill', transaction).then(function () {
              vm.reset()
              vm.message = 'Gasto guardado correctamente'
              vm.snackbar = true
              vm.color = 'green'
              vm.$emit('close')
            })
          }
        }
      },

      onResize () {
        this.isMobile = window.innerWidth < 1024
      },
      invalidForm () {
        const vm = this
        if (
          vm.isLoading ||
          vm.imageLoading ||
          !vm.model.location_to ||
          !vm.model.amount ||
          !vm.model.title ||
          vm.model.title.length > 30 ||
          !vm.model.description ||
          vm.model.description.length > 300
        ) return true

        return false
      },
    },

  }
</script>
<style scoped lang="scss">
  $break-large: 1200px;
  $primary-color: #c29f52;

  .purchase-form{
    &__input{
      flex-wrap: wrap;
      @media screen and (min-width: $break-large) {
        flex-wrap: nowrap;
      }
    }
  }

  .grid-picker{
    text-align: center;
    min-width: 100%;
    display: grid;
    position: relative;
    flex: 1;
    width: 100%;
    grid-template-areas:

      'picture picture '
      'title title '
      'button button';
    @media screen and (min-width: $break-large) {
      grid-template-areas:

        'title picture picture '
        'title picture picture '
        'button button button';
      .image-slot{
        min-width: 400px;
        height: 250px;
        overflow: hidden;
      }
    }

    grid-gap: 10px;

    padding: 10px;
    .picker-btn{

      grid-area: button;
      flex: 1;
      height: 50px;
    }
    .image-slot{
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      display: flex;
      grid-area: picture;
      max-width: 350px;
      max-height: 250px;
      background: #9e9e9e;
      align-items:center;
      justify-content: center;

    }
  }

  .phone-screen{

    background: url("/img/phone.png");
    display:flex;
    flex-direction: column;
    border-radius: 50px;
    border: 1px solid black;

    min-width: 379px;
    min-height: 736px;
    background-size:  379px 736px;
    background-repeat: no-repeat;
    margin:auto;
    overflow: hidden;
    &__content{

      overflow-y: auto;
      max-width: 382px;
      max-height: 595px;
      margin: auto !important;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      padding: 0 15px;
    }
  }
  .main-carousel{
    position: relative;
    &__overlay{
      position: absolute;
      bottom:0;
      left:0;
      right:0;
      height: 45px;
      width: 100%;
      margin: auto !important;
      background:rgba(#000,0.5);
      color: #fff;
      text-align: center;

    }
  }
  .property-values{
    border: 1px solid #c29f52;
    border-radius: 30px;
    height: auto;
    padding: 0 10px;
    h3{
      color:#c29f52;
      font-weight: 900;

    }
    .price-tooltip{
      color:#c29f52;
      font-weight: bold;
      margin:auto;
      margin-top:-10px;
      max-width: 100px;
      border: 1px solid #c29f52;
      border-radius: 15px;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
      border-top: none;
    }
  }
  .numPayments{
    background: white !important;
    border: 1px solid #777;
    border-radius: 25px;
    width:auto;
    max-width: fit-content;

    &__button{
      color:#000 !important;
      border-radius: 40px;
    }
  }
  .v-input--slider{
    margin-top:0;
  }
  .v-tabs__container{
    max-width: 100%;
    overflow-x: auto;

  }
  .property-sections{
    span,b{
      font-size: 15px !important;
    }

    .v-tab{
      color: black !important;
    }
  }
  .property-toolbar{

  }
</style>
